import { OnInit, Input, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { Control } from '../models/formulario-dinamico.model';
import { Static } from '../util/static';

@Component({
  selector: 'iw-button-view-form-dynamic',
  template: '<p>{{ textNumber }}</p>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class ThousandsSeparatorNumberFormatComponent implements ViewCell, OnInit {
  // Entrada del valor del label
  @Input() value: any;
  // Entrada de la fila
  @Input() rowData: any;
  // Configuracion del campo
  control: Control;
  // Texto numero
  textNumber = '';

  ngOnInit() {
    if (this.value) {
      if (this.control.propiedades['separadorMiles']) {
        this.textNumber = Static.applyThousandsSeparatorFormat(
          this.value,
          this.control.propiedades['separadorMiles'],
          this.control.propiedades['separadorDecimales']
        );
      } else {
        this.textNumber = this.value;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/thousands-separator-number-format.component.ts